import BlogItem from "@/components/blog/BlogItem";
import SideBar from "@/components/blog/SideBar";
import { TracingBeam } from "@/components/blog/TracingBeam";
import { blogData } from "@/data/blog";
import BlogSEO from "@/seo/SingleBlogSeo";

function singleBlog({ blog }) {

  const breadcrumbItems = [
    { label: 'Home', href: '/' },
    { label: 'Blog', href: '/blog' },
    { label: blog.title },
  ];


  return (
    <>
      <BlogSEO {...blog} />
      <div className=" flex-col gap-5 xl:flex-row flex md:pt-10 justify-between md:px-10 lg:justify-around items-start mx-auto h-auto w-full max-w-[1600px]  ">
        <TracingBeam blog={blog} breadcrumbItems={breadcrumbItems} />
        <SideBar />
      </div>
      <div className=" mx-auto w-full max-w-7xl px-5 md:px-0 ">
        <div className=" sm:ml-10 my-5 md:mb-5 md:mt-20">
          <h2 className=" font-bold text-xl capitalize  ">Related Blogs</h2>
        </div>

        <div className="mb-6  grid grid-cols-1 justify-items-center md:px-10 gap-8 sm:justify-items-stretch md:mb-10 sm:grid-cols-2 lg:grid-cols-3 md:gap-4 lg:mb-12">
          {blogData.slice(0,6).map((e, i) => (
            <BlogItem key={i} {...blogData[i]} />
          ))}
        </div>
      </div>
    </>
  );
}

export default singleBlog;


// Assume blogData is imported from another file
// Create a lookup map for all blogs by slug
const blogLookup = blogData.reduce((acc, blog) => {
  acc[blog.slug] = blog;
  return acc;
}, {});

// Export blog slugs for faster mapping in getStaticPaths
export const blogSlugs = Object.keys(blogLookup);


export async function getStaticPaths() {
  // Use the precomputed blogSlugs for paths
  const paths = blogSlugs.map((slug) => ({
    params: { slug },
  }));

  return { paths, fallback: false };
}

export async function getStaticProps({ params }) {
  const { slug } = params;

  // Retrieve the blog directly from the blogLookup map
  const blog = blogLookup[slug] || null;

  return {
    props: {
      blog,
    },
  };
}

